export default "__VITE_PUBLIC_ASSET__d7828be5__"